import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className"];
import React from 'react';
import { connect } from 'react-redux';
import { withRenderFlag } from '@beef/react';
import { compose } from '@beef/utils';
import { LeaveYourPhone } from '@fttb/common/components';
import { callbackRequestTextsShape } from '@fttb/common/types';
import PropTypes from 'prop-types';
import { withAnalyticsOnBlockView } from "../hoc/withAnalyticsOnView";
import { LeavePhone } from "./connected";
import { getLeavePhoneBlockTitle } from "../../store/blocks/leavePhone/selectors";
import { getAnalyticEventType, getLeavePhoneBlock, isPageTypeFmc } from "../../store/blocks/selectors";
import { selectIsFttbPersonalVerificationCheckboxEnable } from "../../store/callbackRequest/selectors";
import { getCallbackRequestData } from "../../store/shared/selectors";
import { FttbBlocks } from "../constants";
import { defineBlock } from "../utils";
var _LeavePhoneBlock = function _LeavePhoneBlock(_ref) {
  var className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    "data-t-id": "blocks-LeavePhoneBlock"
  }, /*#__PURE__*/React.createElement(LeaveYourPhone, _extends({}, props, {
    phone: /*#__PURE__*/React.createElement(LeavePhone, null)
  })));
};
_LeavePhoneBlock.propTypes = process.env.NODE_ENV !== "production" ? {
  callBackRequestData: PropTypes.shape({
    text: PropTypes.shape(callbackRequestTextsShape)
  }),
  className: PropTypes.string,
  connectionQuestionsBlock: PropTypes.shape({
    imgUrl: PropTypes.string,
    phoneNumbers: PropTypes.string,
    title: PropTypes.string
  }),
  leavePhoneData: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.arrayOf(PropTypes.shape({}))]),
  shouldRender: PropTypes.bool
} : {};
var mapStateToProps = function mapStateToProps(state) {
  return {
    analyticBlockTitle: getLeavePhoneBlockTitle(state),
    callBackRequestData: getCallbackRequestData(state),
    isConvergent: isPageTypeFmc(state),
    leavePhoneData: getLeavePhoneBlock(state).content,
    pageType: getAnalyticEventType(state),
    isPersonalVerificationCheckboxEnable: selectIsFttbPersonalVerificationCheckboxEnable(state),
    shouldRender: !!getCallbackRequestData(state)
  };
};
var _LeavePhoneBlockHOC = withAnalyticsOnBlockView(_LeavePhoneBlock);
export var LeavePhoneBlock = compose(defineBlock(FttbBlocks.LEAVE_PHONE), connect(mapStateToProps), withRenderFlag)(_LeavePhoneBlockHOC);